import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Notice from '@/components/Notice.vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectAnyTokensNotice',
  setup(__props) {

const { t } = useI18n();

const translation = t('portfolio.easyModeTranslations.common.notices.selectMoreTokens');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Notice, {
    icon: "check",
    text: _unref(translation)
  }, null, 8, ["text"]))
}
}

})